// extracted by mini-css-extract-plugin
export default {"BulletinContainer":"index_BulletinContainer__nj8mB","Item":"index_Item__lQmmA","Title":"index_Title__UCn++"};